/**
 * @Author：zsj
 * @Date：2022/01/06
 */


/*eslint-disable no-unused-vars*/

import { bindActionCreators } from 'redux'
import store from '../index'
import * as actions from '../actions'

let _instance = null

const LOGIN_INFO_KEY = 'LOGIN_INFO_KEY'

class DataControl {

    constructor() {
        if (_instance) {
            throw new Error('禁止new DataControl()')
        }

        this.store = store
        this.actions = bindActionCreators(actions, store.dispatch);

        // 存储一些全局临时变量()
        this._values = {}

    }

    static getInstance() {
        _instance = _instance || new this()
        return _instance
    }

    setValue(key, value) {
        this._values = {
            ...this._values,
            [key]: value
        }
    }

    getValue(key) {
        return this._values[key]
    }

    showLoading = () => {
        const fn = this._values['global_loading_fn']
        fn(true)
        return this.hideLoading
    }

    hideLoading = () => {
        const fn = this._values['global_loading_fn']
        fn(false)
    }

    setCacheLoginInfo(info) {
        localStorage.setItem(LOGIN_INFO_KEY, JSON.stringify(info))
    }

    clearCacheLoginInfo() {
        localStorage.clear(LOGIN_INFO_KEY)
    }

    getCacheLoginInfo() {
        try {
            return JSON.parse(localStorage.getItem(LOGIN_INFO_KEY))
        } catch (e) {
            return null
        }
    }

    getPermissionArr() {
        const loginInfo = this.getCacheLoginInfo() || {}
        return loginInfo.routerArr || []
    }

}

export default DataControl.getInstance()
